// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewModal-previewModelImage-SD363 {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    border-radius: 12px;
}

.PreviewModal-siteSettingPreviewModel-oush1 {
    max-width: 944px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/SiteSettingsForm/PreviewModal/PreviewModal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".previewModelImage {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 12px;\n}\n\n.siteSettingPreviewModel {\n    max-width: 944px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewModelImage": `PreviewModal-previewModelImage-SD363`,
	"siteSettingPreviewModel": `PreviewModal-siteSettingPreviewModel-oush1`
};
module.exports = ___CSS_LOADER_EXPORT___;
